"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicSchema = void 0;
var zod_1 = require("zod");
var ObjectId_1 = require("./lib/ObjectId");
var utils_1 = require("./lib/utils");
exports.TopicSchema = zod_1.z.object({
    title: zod_1.z
        .string()
        .trim()
        .min(5, { message: 'Title is too short' })
        .max(25, { message: 'Title is too long' })
        .refine(utils_1.isStringHTMLValid, { message: 'Title has invalid letters' }),
    description: zod_1.z.string().min(5, { message: 'Description is too short' }),
    channelId: (0, ObjectId_1.ObjectIdString)('Invalid channel id'),
    image: zod_1.z.string().optional(),
    imagePublicId: zod_1.z.string().optional(),
});
//# sourceMappingURL=Topic.js.map